import React from 'react'

export const getErrorMessageController = (fieldState: any, addErrorPrefix?:boolean): string | null => { // ControllerFieldState from react-hook-form
  if (addErrorPrefix) {
    return fieldState.error?.message ? prefixErrorText(fieldState.error.message) : null
  } else {
    return fieldState.error?.message ? fieldState.error.message : null
  }
}

export const getClassNames = (defaultClassNames:string, errorCondition: boolean, errorClassName:string):string => {
  return `${defaultClassNames} ${errorCondition ? errorClassName : ''}`.trim()
}

export const getErrorMessageRegister = (errorCondition: boolean, errorMessage: string, errorClassName:string): any => {
  if (errorCondition) {
    return <span className={`${errorClassName} ds-c-field__error-message`}>{errorMessage}</span>
  }
}

export const prefixErrorText = (string: string) => {
  return `Error: ${string}`
}
